/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

// @services
import servicioService from '../services/servicioService';
import companyPatnersService from '../services/companyPatnersService';
import inmobiliariasService from '../services/inmobiliariasService';
import unidadesResidencialesService from '../services/unidadesResidencialesService';

// @utils
import { PAYMENT_STATUS_VALUES, USER_ROLES } from '../utils/ConstantsUtils';
import ConfirmModal from '../components/modals/ConfirmModal';

const LeadsPartnes = () => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    totalLeads: 0,
    totalPagos: 0,
    proximoMes: 0
  });

  const [partnersAgrupados, setPartnersAgrupados] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [partnerSeleccionado, setPartnerSeleccionado] = useState(null);
  const [requestsPartner, setRequestsPartner] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [expandedPartnerId, setExpandedPartnerId] = useState(null);
  const [entitySelected, setEntitySelected] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    fetchMonthlyPartnerStats();
  }, [selectedYear, selectedMonth]);

  // function to fetch monthly leads stats
  const fetchMonthlyPartnerStats = async () => {
    try {
      setLoading(true);
      const data = await servicioService.getMonthlyPartnerStats(selectedYear, selectedMonth);
      const partnersList = Array.isArray(data) ? data : [];
      successFetchMonthlyPartnerStats(partnersList);
      setError(null);
      toast.success('Estadísticas mensuales obtenidas');
    } catch (err) {
      setError('No se pudieron cargar las estadísticas. Por favor, intenta de nuevo más tarde.');
      toast.error('Error al cargar estadísticas');
    } finally {
      setLoading(false);
    }
  };

  // function to success fetch monthly partner stats
  const successFetchMonthlyPartnerStats = (partnersList) => {
    const partnersMapped = mapPartnersData(partnersList);

    setPartnersAgrupados(partnersMapped);
    const totalLeads = partnersMapped?.reduce((sum, partner) => sum + partner.totalServicios, 0);
    const totalPagos = partnersMapped?.reduce((sum, partner) => sum + partner.costoLeads, 0);
    const nextMonth = partnersMapped?.filter(partner => partner.status === PAYMENT_STATUS_VALUES.pending)?.reduce((sum, partner) => sum + partner.costoLeads, 0);
    setStats({
      totalLeads,
      totalPagos,
      proximoMes: nextMonth
    });
  };

  // function to map partners data
  const mapPartnersData = (partnersArray) => {
    const partnersMapped = partnersArray?.map(partner => ({
      userId: partner.partnerId,
      partnerId: partner.partnerId,
      nombre: partner.partnerName || 'Sin nombre',
      totalServicios: partner.serviceCount || 0,
      costoLeads: parseFloat(partner.totalPrice || 0),
      serviceId: partner.userId,
      role: partner.role || 'Sin rol',
      entity: partner.entityId,
      status: partner.status
    }));
    return partnersMapped;
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'Fecha inválida';
    }
  };

  // Función para formatear moneda
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Función optimizada para abrir el modal con los servicios de un partner
  const handlePartnerClick = async (partner) => {
    try {
      setPartnerSeleccionado(partner);
      setModalOpen(true);
      setLoadingModal(true);

      const response = await servicioService.getPartnerMonthlyServices(
        partner?.partnerId,
        selectedYear,
        selectedMonth
      );
      setRequestsPartner(response?.data?.length > 0 ? response?.data : []);
      toast.success('Servicios cargados correctamente');
    } catch (err) {
      toast.error('Error al cargar los servicios del partner');
      setRequestsPartner([]);
    } finally {
      setLoadingModal(false);
    }
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setModalOpen(false);
    setPartnerSeleccionado(null);
    setRequestsPartner([]);
  };

  const getPartnerById = async (id) => {
    try {
      setLoadingDetails(true);
      const response = await companyPatnersService.getCompanyPatnerById(id);
      setEntitySelected(response);
      setLoadingDetails(false);
    } catch (error) {
      setLoadingDetails(false);
      toast.error('Error al obtener el socio, intente nuevamente mas tarde');
    }
  };

  const getRealStateById = async (id) => {
    try {
      setLoadingDetails(true);
      const response = await inmobiliariasService.getInmobiliariaById(id);
      setEntitySelected(response);
      setLoadingDetails(false);
    } catch (error) {
      setLoadingDetails(false);
      toast.error('Error al obtener la inmobiliaria, intente nuevamente mas tarde');
    }
  };

  const getUserAdminUnitById = async (id) => {
    try {
      setLoadingDetails(true);
      const response = await unidadesResidencialesService.getUnidadResidencialById(id);
      setEntitySelected(response);
      setLoadingDetails(false);
    } catch (error) {
      toast.error('Error al obtener el usuario administrador de la unidad, intente nuevamente mas tarde');
      setLoadingDetails(false);
    }
  };

  const getEntityById = (data) => {
    if (data.role === USER_ROLES.COMPANY_PARTNER) return getPartnerById(data.entity);
    if (data.role === USER_ROLES.INMOBILIARIA) return getRealStateById(data.entity);
    if (data.role === USER_ROLES.USER_ADMIN_UNIT) return getUserAdminUnitById(data.entity);
    return setLoadingDetails(false);
  };

  // Función para expandir/colapsar el método de pago
  const handleTogglePaymentMethod = (e, data) => {
    e.stopPropagation();
    if (!expandedPartnerId || expandedPartnerId !== data.userId) getEntityById(data);
    setExpandedPartnerId(expandedPartnerId === data.userId ? null : data.userId);
  };

  const handleChangeStatus = (data) => {
    if (data.status && data.status === PAYMENT_STATUS_VALUES.paid) return toast.warning('El lead ya está pagado');
    setPartnerSeleccionado(data);
    setShowConfirmModal(true);
  };

  const confirmChangeStatus = () => {
    const data = {
      partnerId: partnerSeleccionado.partnerId,
      entityId: partnerSeleccionado.entity,
      partnerName: partnerSeleccionado.nombre,
      role: partnerSeleccionado.role,
      totalPrice: partnerSeleccionado.costoLeads,
      serviceCount: partnerSeleccionado.totalServicios,
      status: partnerSeleccionado.status
    };
    updatePartnerStatus(data);
  };

  const updatePartnerStatus = async (data) => {
    try {
      const response = await servicioService.updatePartnerStatus(data);
      if (response.status >= 200 && response.status < 399) {
        toast.success('Estado del lead actualizado correctamente');
        fetchMonthlyPartnerStats();
      } else {
        toast.error('Error al actualizar el estado del lead, intente nuevamente mas tarde');
      }
    } catch (error) {
      toast.error('Error al actualizar el estado del lead, intente nuevamente mas tarde');
    }
  };

  const cancelChangeStatus = () => {
    setShowConfirmModal(false);
    setPartnerSeleccionado(null);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Dashboard de Socios</h2>

      {/* Filtros de año y mes */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-6">
        <h3 className="text-lg font-medium text-gray-700 mb-4">Filtros</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Año
            </label>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mes
            </label>
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map(month => (
                <option key={month} value={month}>
                  {new Date(2024, month - 1).toLocaleDateString('es-ES', { month: 'long' })}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Cards de estadísticas */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* Card 1: Total de Leads */}
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-blue-500">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-blue-100 mr-4">
              <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Total Leads Conseguidos</p>
              <p className="text-2xl font-bold">{stats.totalLeads}</p>
            </div>
          </div>
        </div>

        {/* Card 2: Precio Total */}
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-green-500">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-green-100 mr-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Precio Total de Leads</p>
              <p className="text-2xl font-bold">{formatCurrency(stats.totalPagos)}</p>
            </div>
          </div>
        </div>

        {/* Card 3: Próximo Mes */}
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-purple-500">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-purple-100 mr-4">
              <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Costo a pagar Próximo Mes</p>
              <p className="text-2xl font-bold">{formatCurrency(stats.proximoMes)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla de empresas */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">Socios y sus Leads</h3>

        {/* Estado de carga y error */}
        {loading && <p className="mt-4 text-gray-600">Cargando datos...</p>}
        {error && <p className="mt-4 text-red-500">{error}</p>}

        {/* Tabla */}
        {!loading && !error && (
          <div className="overflow-x-auto mt-6">
            <table className="min-w-full bg-white">
              <thead>
                <tr className="w-full h-16 border-gray-300 border-b py-8">
                  <th className="text-left pl-6 font-bold text-gray-600">Socio</th>
                  <th className="text-left pl-6 font-bold text-gray-600">Rol</th>
                  <th className="text-center font-bold text-gray-600">Número de Servicios</th>
                  <th className="text-center font-bold text-gray-600">Método de Pago</th>
                  <th className="text-center font-bold text-gray-600">Pagado</th>
                  <th className="text-right pr-6 font-bold text-gray-600">Costo Leads</th>
                </tr>
              </thead>
              <tbody>
                {partnersAgrupados.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-6 text-gray-500">
                      No hay partners registrados.
                    </td>
                  </tr>
                ) : (
                  partnersAgrupados.map(partner => (
                    <React.Fragment key={partner.userId}>
                      <tr
                        className="h-16 border-gray-300 border-b hover:bg-gray-50 cursor-pointer transition-colors"
                        onClick={() => handlePartnerClick(partner)}
                        title="Haz clic para ver los servicios de este partner"
                      >
                        <td className="py-3 px-6 text-left font-medium">{partner.nombre}</td>
                        <td className="py-3 px-6 text-left font-medium">{partner.role}</td>
                        <td className="py-3 px-6 text-center">{partner.totalServicios}</td>
                        <td className="py-3 px-6 text-center">
                          <div className="flex items-center justify-center gap-2">
                            <span className="font-medium">Banco</span>
                            <button
                              onClick={(e) => {
                                setEntitySelected(null);
                                handleTogglePaymentMethod(e, partner)
                              }}
                              className="text-blue-500 hover:text-blue-700 transition-colors"
                              title="Ver información de pago"
                            >
                              <svg
                                className={`w-5 h-5 transition-transform duration-300 ${expandedPartnerId === partner.userId ? 'rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                              </svg>
                            </button>
                          </div>
                        </td>
                        <td className="py-3 px-6 text-center">
                          <div className="flex items-center justify-center">
                            <input type="checkbox"
                              checked={partner.status && partner.status === PAYMENT_STATUS_VALUES.paid}
                              onClick={(e) => e.stopPropagation()}
                              onChange={() => handleChangeStatus(partner)}
                              className="w-5 h-5 border border-gray-300 rounded-md"
                            />
                          </div>
                        </td>
                        <td className="py-3 px-6 text-right">{formatCurrency(partner.costoLeads)}</td>
                      </tr>
                      {/* Fila expandible con información del método de pago */}
                      {expandedPartnerId === partner.userId && (
                        <tr className="bg-gray-50">
                          <td colSpan="6" className="px-6 py-4">
                            {!loadingDetails && entitySelected !== null && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div className="bg-blue-50 p-4 rounded-lg">
                                  <h4 className="font-semibold text-gray-700 mb-3">Datos Bancarios</h4>
                                  <div className="flex items-center gap-3">
                                    <svg className="w-10 h-10 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                                    </svg>
                                    <div>
                                      <p className="text-gray-700 font-bold">
                                        {entitySelected?.banco}
                                      </p>
                                      <p className="text-gray-500 text-sm">
                                        <span className="font-bold">Tipo de cuenta:</span> {entitySelected?.tipo_Cuenta}
                                      </p>
                                      <p className="text-gray-500 text-xs mt-1">
                                        <span className="font-bold">Cuenta bancaria:</span> {entitySelected?.numero_Cuenta}
                                      </p>
                                      <p className="text-gray-500 text-xs mt-1">
                                        <span className="font-bold">Titular:</span> {entitySelected?.nombre_Titular}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="bg-blue-50 p-4 rounded-lg">
                                  <h4 className="font-semibold text-gray-700 mb-3">Datos Breve</h4>
                                  <div className="flex items-center gap-3">
                                    <svg className="w-10 h-10 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                                    </svg>
                                    <div>
                                      <p className="text-gray-700 font-bold">
                                        <span className="font-bold">Tipo de llave:</span> {entitySelected?.type_LLave}
                                      </p>
                                      <p className="text-gray-500 text-sm">
                                        <span className="font-bold">Número de llave:</span> {entitySelected?.number_LLave}
                                      </p>
                                      <p className="text-gray-500 text-xs mt-1">
                                        <span className="font-bold">Titular:</span> {entitySelected?.titular_Breve}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}
                            {loadingDetails && entitySelected === null && <div className="flex justify-center items-center py-4">
                              <div className="text-gray-600">Cargando información...</div>
                            </div>}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr className="h-16 bg-gray-50">
                  <td colSpan="2" className="py-3 px-6 text-left font-bold">Totales</td>
                  <td className="py-3 px-6 text-center font-bold">{stats.totalLeads}</td>
                  <td className="py-3 px-6 text-center"></td>
                  <td className="py-3 px-6 text-center"></td>
                  <td className="py-3 px-6 text-right font-bold">{formatCurrency(stats.totalPagos)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      {/* Modal para mostrar servicios del partner */}
      {modalOpen && partnerSeleccionado && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-6xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold">
                Servicios de {partnerSeleccionado.nombre}
              </h3>
              <button
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
              >
                ×
              </button>
            </div>

            <div className="mb-4">
              <p className="text-gray-600">
                <strong>Total de servicios:</strong> {partnerSeleccionado.totalServicios} |
                <strong> Costo total de leads:</strong> {formatCurrency(partnerSeleccionado.costoLeads)}
              </p>
            </div>

            {/* Estado de carga del modal */}
            {loadingModal ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-600">Cargando servicios del partner...</div>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Usuario
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Servicio
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Fecha
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Categoría
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Precio Lead
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {requestsPartner.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                          No hay servicios para este partner en el período seleccionado.
                        </td>
                      </tr>
                    ) : (
                      requestsPartner?.map((request, index) => (
                        <tr key={`${request?.serviceId}-${request?.userId}-${index}`} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {request?.userName || 'Usuario desconocido'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {request?.serviceTitle || request?.serviceName || 'Sin nombre'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatDate(request?.serviceDate || request?.createdAt)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {request?.categoryName || 'Sin categoría'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                            {formatCurrency(parseFloat(request?.leadPrice) || 0)}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  {requestsPartner?.length > 0 && (
                    <tfoot className="bg-gray-50">
                      <tr>
                        <td colSpan="4" className="px-6 py-3 text-left text-sm font-medium text-gray-900">
                          Total
                        </td>
                        <td className="px-6 py-3 text-right text-sm font-medium text-gray-900">
                          {formatCurrency(partnerSeleccionado.costoLeads)}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            )}

            <div className="mt-6 flex justify-end">
              <button
                onClick={handleCloseModal}
                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={cancelChangeStatus}
        onConfirm={confirmChangeStatus}
        title="Cambiar Estado"
        message="¿Está seguro que desea cambiar el estado del lead?"
        confirmText="Sí, cambiar estado"
        cancelText="Cancelar"
        confirmButtonColor="bg-green-600 hover:bg-green-700"
      />
    </div>
  );
};

export default LeadsPartnes;
